import { AuthContext } from '@/components/Contexts/AuthContext';
import { FC, PropsWithChildren, useContext } from 'react';
import { Navigate, useParams } from 'react-router-dom';

const AdminOnly: FC<PropsWithChildren> = ({ children }) => {
  const { auth } = useContext(AuthContext);
  const { lang = 'nl' } = useParams();

  if (auth === undefined) return null;

  if ((auth?.user?.role || 0) < 90) {
    return <Navigate replace to={`/${lang}/noaccess`} />;
  }

  return <>{children}</>;
};

export { AdminOnly };
